import * as React from 'react';

import {FeatureGateModalWrapper} from '../../limits/feature-gates/feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function SmsTrialModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            title='Connect with customers through the Engagement Suite'
            isOpen={props.isOpen}
            bullets={[
                'Reach out to leads and customers directly on their phones for quick conversations.',
                'Grow your outreach and make connections in a space they‘re comfortable with.',
                'Get instant notifications for new messages and thread assignments to stay in the loop.',
                'Schedule automated texts to keep the conversation flowing at important moments in your sales journey.',
            ]}
            description={
                'Reach your customers where they are—on their phones! SMS offers a convenient way to communicate, keeping your connections strong and responsive.'
            }
            feature='SMS'
            onClose={props.onClose}
        />
    );
}
